import React, { Component } from 'react'
import { FacebookShareButton, TwitterShareButton } from 'react-share'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import {
  USER_MEDIUM_PARAMS,
  userPhotoID,
} from '../../../constants/images/sizesAndQuality'
import { Button, Header, Columns, Container } from '../../elements'
import cloudinary from 'cloudinary-core'
import EmailInvitesInput from './emailInvitesInput.js'
import {
  trackReferralsViewInviteScreen,
  trackReferralsCopiedReferralLink,
  trackReferralsClickedFacebook,
  trackReferralsClickedTwitter,
} from '../../elements/tracking/referralsTracking.js'
import BigRef from './bigRef/bigRef.js'
import CopyRefCode from './copyLink/copyLink.js'
import './../referralsInviteLayout.css'
import './../referrals.css'
import { apiProcess } from 'components/api/api'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

class ReferralsInviteLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      refCopied: false,
      referral_data: {
        concession_days: null,
        trip_duration_days: null,
        concession_discount_rate: null
      }
    }
    document.body.classList.add('ref-invite-page')
  }

  componentDidMount() {
    const apiURL = 'referrals/info'
    apiProcess(
      apiURL,
      false,
      'get-referral-info',
      'Get a referral information'
    )
    .then((responseData) => {
      this.setState({
        referral_data: responseData.referral_data
      })
    })
    .catch((error) => {
      let message =
        'Oops. Something went wrong. If you continue to experience issues, please contact us at info@twistedroad.com'
      if (error.errorResponseData.errors) {
        message = error.errorResponseData.errors[0]
      }
      console.log('referral fetch error', error)
    })
    trackReferralsViewInviteScreen(this.props.data)
  }

  componentWillUnmount() {
    document.body.classList.remove('ref-invite-page')
  }

  onCopyLink = () => {
    this.setState({ refCopied: true })
    trackReferralsCopiedReferralLink()
    setTimeout(() => this.setState({ refCopied: false }), 2500)
  }

  render() {
    const { data } = this.props
    const { referral_data } = this.state
    return (
      <div className="referrals-invite-wrap">
        <div className="ref-invite-top">
          <Container className="small ref-container">
            <Columns>
              <Columns.Column className="has-text-centered ref-invite-header">
                <img
                  src={cl.url(userPhotoID(data.avatar), USER_MEDIUM_PARAMS)}
                  className="ref-header-user accept"
                  alt={'Referral from ' + data.acceptFirstName}
                />
                <span className="referrals-eyebrow">
                  Want more friends with benefits?
                </span>
                <div className="ref-description">
                  {data.first_name}, invite your friends to give them a Free Day
                  of riding. When they take their first trip or list their first
                  motorcycle, you’ll get $25 in your account.
                </div>
                <div className="referrals-header">
                  Give a Free Day, Get $25 Dollars
                </div>
              </Columns.Column>
            </Columns>
            <EmailInvitesInput />
          </Container>
        </div>

        <Container className="ref-invite-white-wrap-inner has-text-centered pb-6 share-now-container">
          <Header renderas="h2" size={3}>
            SHARE NOW
          </Header>
          <Columns className="ref-tools-wrap">
            <Columns.Column size={6} className="ref-share-left">
              <BigRef refCode={data.referral_code} />

              <CopyRefCode refCode={data.referral_code} />
            </Columns.Column>
            <Columns.Column size={6} className="ref-share-wrap pt-6">
              <FacebookShareButton
                quote={
                  'Use my referral link to get a Free Day on your first Motorcycle Rental on Twisted Road! https://www.twistedroad.com/ref/' +
                  data.referral_code
                }
                url={'https://www.twistedroad.com/ref/' + data.referral_code}
                beforeOnClick={() => trackReferralsClickedFacebook()}
              >
                <Button className="ref-share-button" color="facebook">
                  <i className="fab fa-facebook-f"></i> Post on Facebook
                </Button>
              </FacebookShareButton>
              <TwitterShareButton
                title={
                  'Use my referral link to get a Free Day on your first Motorcycle Rental on Twisted Road! https://www.twistedroad.com/ref/' +
                  data.referral_code
                }
                url={'https://www.twistedroad.com/ref/' + data.referral_code}
                beforeOnClick={() => trackReferralsClickedTwitter()}
              >
                <Button className="ref-share-button" color="twitter">
                  <i className="fab fa-twitter"></i> Post on Twitter
                </Button>
              </TwitterShareButton>
            </Columns.Column>
          </Columns>
        </Container>
        <div className="ref-invite-more-info">
          <Columns className='refer-wrapper'>
            <Columns.Column size={6} className="content">
              <Header
                renderas="h2"
                size={5}
                className="has-text-weight-extra-bold mt-5"
              >
                Refer a Rider
              </Header>

              <p className='has-text-centered'>
                You'll get $25 and you'll be hooking up your friend with a
                massive discount on their first ride:
              </p>

              <p className="has-text-centered">
                {referral_data.concession_days} free day of riding when
                <br />
                they book for {referral_data.trip_duration_days} or more days
              </p>
              <div className="divider">OR</div>
              <p className="has-text-centered">
                {referral_data.concession_discount_rate * 100}% if they book for less than {referral_data.trip_duration_days} days.{' '}
              </p>
            </Columns.Column>
          </Columns>
        </div>
      </div>
    )
  }
}

export default ReferralsInviteLayout

ReferralsInviteLayout.defaultProps = {
  data: null,
}
